import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import ProtectedRoute from './ProtectedRoute';
import ProductWeightPage from '../pages/ProductWeightPage';
import TruckWeightPage from '../pages/TruckWeightPage';
import CustomerPage from '../pages/CustomerPage';
import ProductPage from '../pages/ProductPage';
import BillPage from '../pages/BillPage';
import useAuthStore from '../stores/authStore';

const AppRoute: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <BrowserRouter>
      <Routes>
        {/* Root redirect */}
        <Route
          path="/"
          element={
            isAuthenticated ?
              <Navigate to="/dashboard" replace /> :
              <Navigate to="/login" replace />
          }
        />

        {/* Login route */}
        <Route
          path="login"
          element={
            isAuthenticated ?
              <Navigate to="/dashboard" replace /> :
              <LoginPage />
          }
        />

        {/* Logout route */}
        <Route
          path="logout"
          element={<Navigate to="/login" replace />}
        />

        {/* Protected routes with AppLayout */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<AppLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="product-weight" element={<ProductWeightPage />} />
            <Route path="truck-weight" element={<TruckWeightPage />} />
            <Route path="customer" element={<CustomerPage />} />
            <Route path="product" element={<ProductPage />} />
            <Route path="bill" element={<BillPage />} />
            <Route path="profile" element={<div>Profile Page (Protected)</div>} />
          </Route>
        </Route>

        {/* Catch-all route for 404s */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;